import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight, FiCommand, FiUser } from 'react-icons/fi';
import Button from './Button';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const CardTemplates = ({
  title,
  department,
  description,
  pessoa,
  data,
  status,
  statusLabel,
  avatar,
  variant,
}) => {
  const navigate = useNavigate();

  const getStatusLabelColor = (label) => {
    switch (label) {
      case 'Hoje':
        return 'bg-blue-500 bg-opacity-15 text-blue-700';
      case 'A Vencer':
        return 'bg-yellow-500 bg-opacity-15 text-yellow-700';
      case 'Vencida':
        return 'bg-red-500 bg-opacity-15 text-red-700';
      default:
        return 'bg-gray-200 text-black'; 
    }
  };

  if (variant === 'primary') {
    return (
      <div className="bg-white rounded-lg border p-4 sm:p-5 md:p-6 w-full min-h-[120px] max-w-[500px] sm:min-h-[150px] md:min-h-[180px] flex flex-col justify-between">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-6 h-6 sm:w-7 sm:h-7 bg-gray-100 rounded-md flex items-center justify-center flex-shrink-0">
            <FiCommand className="w-3 h-3 sm:w-4 sm:h-4 text-[#3c0f55]" />
          </div>
          <span className="text-xs sm:text-sm font-semibold text-gray-800 line-clamp-2">
            {title}
          </span>
        </div>
        <div className='flex mt-4'>
          <span className="text-xs font-medium bg-[#3f1057]/10 px-3 py-1 rounded-2xl">{department}</span>
        </div>
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mt-4 gap-3">
          <div className="flex flex-col gap-1">
            <span className="text-xs sm:text-sm text-gray-600">{description}</span>
          </div>
        </div>
        <Button className='mt-3' variant='outline'>{department === 'Novo Template' ? 'Criar nova sequência' : 'Usar'}</Button>
      </div>
    );
  }
  return (
    <div className="bg-white rounded-lg border p-3 w-full flex items-center">
      <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 border border-gray-100 mr-3 self-center">
        {avatar ? (
          <img
            src={avatar}
            alt={pessoa}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gray-100 flex items-center justify-center">
            <FiUser className="text-gray-500" />
          </div>
        )}
      </div>

      <div className="flex-grow">
        <h3 className="font-semibold text-sm text-gray-900 line-clamp-1">{title}</h3>
        <div className="flex items-center mt-1 text-xs text-gray-600">
          <span>{pessoa}</span>
        </div>
        
        <div className="mt-1.5">
          <span className={`text-xs px-2 py-0.5 rounded-full ${getStatusLabelColor(statusLabel)}`}>
            {statusLabel}
          </span>
        </div>
      </div>

      <div className="flex items-center ml-auto">
        <motion.a
          href="#"
          initial="rest"
          whileHover="hover"
          animate="rest"
          className="relative inline-flex items-center gap-1 text-xs font-medium rounded-full px-2.5 py-1 bg-gray-100 text-[#3c0f55] transition-colors"
          variants={{
            rest: {
              backgroundColor: '#f3f4f6',
              minWidth: '80px',
            },
            hover: {
              backgroundColor: '#3c0f55',
              color: '#fff',
              minWidth: '90px',
            },
          }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <motion.span
            className="rounded-full flex items-center justify-center flex-shrink-0"
            variants={{
              rest: {
                width: 5,
                height: 5,
                backgroundColor: '#3c0f55',
              },
              hover: {
                width: 14,
                height: 14,
                backgroundColor: '#fff',
              },
            }}
            transition={{ duration: 0.3 }}
          >
            <motion.div
              variants={{
                rest: { opacity: 0, x: -5 },
                hover: { opacity: 1, x: 0 },
              }}
              transition={{ duration: 0.3 }}
            >
              <FiArrowRight className="w-2.5 h-2.5 text-[#3c0f55] flex-shrink-0" />
            </motion.div>
          </motion.span>

          <motion.span
            variants={{
              rest: { color: '#3c0f55' },
              hover: { color: '#fff' },
            }}
            transition={{ duration: 0.3 }}
            className="whitespace-nowrap text-xs"
          >
            Acessar
          </motion.span>
        </motion.a>
      </div>
    </div>
  );
}

CardTemplates.propTypes = {
  title: PropTypes.string.isRequired,
  department: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  pessoa: PropTypes.string,
  data: PropTypes.string,
  status: PropTypes.string,
  statusLabel: PropTypes.string,
  avatar: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary']),
};

export default CardTemplates;